import React, { useState } from 'react';
import {
    TrendingUp,
    People,
    Psychology,
    QueryStats,
    CompareArrows,
    Analytics,
    Map,
    Home,
    Info,
    Link,
    Api,
} from '@mui/icons-material';
import { CarouselSlider, NavigationMenu, TypingTextComponent, ChatBot } from '../../components/atoms';
// import TabComponentExample from 'components/atoms/tab/TabComponentExample';
import CalculatorWrapper from '../../components/atoms/calculator/CalculatorWrapper';

const KhsTempPage = () => {
    const [selectedMenu, setSelectedMenu] = useState('home');
    const [activeItem, setActiveItem] = useState('home');

    // 캐러셀 임시 데이터
    const sampleSlides = [
        {
            image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
            title: '슬라이드 제목 1',
            summary: '슬라이드 요약 1',
            description: '슬라이드 설명 1',
            icon: <TrendingUp />,
        },
        {
            image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
            title: '슬라이드 제목 2',
            summary: '슬라이드 요약 2',
            description: '슬라이드 설명 2',
            icon: <People />,
        },
        {
            image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
            title: '슬라이드 제목 3',
            summary: '슬라이드 요약 3',
            description: '슬라이드 설명 3',
            icon: <Psychology />,
        },
    ];

    // 네비게이션 임시 데이터
    const mainNavItems = [
        {
            id: 'analysis_visualization',
            label: '분석/시각화',
            icon: <QueryStats />,
            submenu: [
                {
                    id: 'statistics_comparison',
                    label: '통계 비교',
                    icon: <CompareArrows />,
                },
                {
                    id: 'point_analysis',
                    label: '포인트 분석',
                    icon: <Analytics />,
                },
            ],
        },
        {
            id: 'new_topic_map',
            label: '신규 주제도',
            icon: <Map />,
            submenu: [
                {
                    id: 'population_info',
                    label: '인구 정보',
                    icon: <People />,
                },
                {
                    id: 'housing',
                    label: '주택 정보',
                    icon: <Home />,
                },
            ],
        },
        {
            id: 'info_provider',
            label: '정보 제공',
            icon: <Info />,
            submenu: [
                {
                    id: 'url_converter',
                    label: 'URL 변환',
                    icon: <Link />,
                },
                {
                    id: 'api_provider',
                    label: 'API 제공',
                    icon: <Api />,
                },
            ],
        },
    ];

    const handleItemClick = (item, parentItem = null) => {
        setActiveItem(item.id);
        setSelectedMenu(item.id);
        console.log('선택된 메뉴:', item);
        if (parentItem) {
            console.log('상위 메뉴:', parentItem);
        }
    };

    // 메뉴별 컨텐츠 컴포넌트
    const renderContent = () => {
        switch (selectedMenu) {
            case 'statistics_comparison':
                return (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>통계 비교</h2>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                gap: '20px',
                                marginTop: '30px',
                            }}
                        >
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>지역별 비교</h3>
                                <p>다양한 지역의 통계 데이터를 비교 분석할 수 있습니다.</p>
                            </div>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>시계열 분석</h3>
                                <p>시간에 따른 데이터 변화를 추적하고 분석합니다.</p>
                            </div>
                        </div>
                    </div>
                );
            case 'point_analysis':
                return (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>포인트 분석</h2>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                gap: '20px',
                                marginTop: '30px',
                            }}
                        >
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>핫스팟 분석</h3>
                                <p>데이터가 집중된 지역을 식별하고 분석합니다.</p>
                            </div>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>클러스터링</h3>
                                <p>유사한 특성을 가진 지역들을 그룹화합니다.</p>
                            </div>
                        </div>
                    </div>
                );
            case 'population_info':
                return (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>인구 정보</h2>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                gap: '20px',
                                marginTop: '30px',
                            }}
                        >
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>인구 밀도</h3>
                                <p>지역별 인구 밀도와 분포를 확인할 수 있습니다.</p>
                            </div>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>연령대별 분포</h3>
                                <p>연령대별 인구 분포와 변화 추이를 분석합니다.</p>
                            </div>
                        </div>
                    </div>
                );
            case 'housing':
                return (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>주택 정보</h2>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                gap: '20px',
                                marginTop: '30px',
                            }}
                        >
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>주택 가격</h3>
                                <p>지역별 주택 가격 동향과 시장 분석을 제공합니다.</p>
                            </div>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>주택 유형</h3>
                                <p>아파트, 단독주택 등 주택 유형별 분포를 확인합니다.</p>
                            </div>
                        </div>
                    </div>
                );
            case 'url_converter':
                return (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>URL 변환</h2>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                gap: '20px',
                                marginTop: '30px',
                            }}
                        >
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>URL 단축</h3>
                                <p>긴 URL을 짧고 기억하기 쉬운 형태로 변환합니다.</p>
                            </div>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>QR 코드 생성</h3>
                                <p>URL을 QR 코드로 변환하여 모바일 접근을 용이하게 합니다.</p>
                            </div>
                        </div>
                    </div>
                );
            case 'api_provider':
                return (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>API 제공</h2>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                gap: '20px',
                                marginTop: '30px',
                            }}
                        >
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>REST API</h3>
                                <p>표준 REST API를 통해 데이터에 접근할 수 있습니다.</p>
                            </div>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef',
                                }}
                            >
                                <h3>GraphQL</h3>
                                <p>GraphQL을 통한 유연한 데이터 쿼리를 지원합니다.</p>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#FDFDFD',
                width: '100%',
                height: '100vh',
            }}
        >
            {/* 1. 타이핑 텍스트 */}
            <div
                style={{
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }}
            >
                <TypingTextComponent
                    originalText="SODAMAP"
                    expandedText="SOcialDAtaMAP"
                    speed={150}
                    delay={1000}
                    pauseTime={2000}
                    reverseSpeed={100}
                    loop={true}
                    size="48px"
                    mobileSize="36px"
                    smallSize="28px"
                />
            </div>

            {/* 2. 캐러셀 */}
            <div
                style={{
                    width: '100%',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    marginBottom: '20px',
                }}
            >
                <CarouselSlider slides={sampleSlides} autoPlay={true} interval={4000} />
            </div>

            {/* 3. 네비게이션 */}
            <div
                style={{
                    width: '100%',
                    borderBottom: '1px solid #e0e0e0',
                }}
            >
                <NavigationMenu
                    items={mainNavItems}
                    variant="horizontal"
                    onItemClick={handleItemClick}
                    activeItem={activeItem}
                />
            </div>

            {/* 4. 네비게이션 컨텐츠 영역 */}
            <div
                style={{
                    flex: 1,
                    paddingTop: '20px',
                }}
            >
                <div
                    style={{
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }}
                >
                    {/* 선택된 메뉴에 따른 추가 컨텐츠 */}
                    {selectedMenu !== 'home' && renderContent()}
                </div>
            </div>

            {/* 5. 챗봇 */}
            <div
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 1000,
                }}
            >
                <ChatBot />
            </div>

            {/* 6. 탭 */}
            {/* <TabComponentExample /> */}

            {/* 7. 계산기 */}
            <CalculatorWrapper />
        </div>
    );
};

export default KhsTempPage;
